import { render, staticRenderFns } from "./SidebarSecondaryItem.vue?vue&type=template&id=43d5ad85&"
import script from "./SidebarSecondaryItem.vue?vue&type=script&lang=js&"
export * from "./SidebarSecondaryItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports